import BaseCollectionService from "./base.collection.service";

class WatercraftTypeService extends BaseCollectionService {
  constructor() {
    super("watercraftTypes");
  }

  async getWatercraftTypes(query?: Record<string, any>) {
    const path = `watercraftTypes`;
    return await this.request(
      {
        method: "get",
        url: path,
        params: query
      },
      { useToken: "access" }
    );
  }

  public async deleteBulkWatercraftTypes(_ids: string[]) {
    const path = `watercraftTypes-bulk`;
    return await this.request(
      {
        method: "delete",
        url: path,
        data: { _ids }
      },
      { useToken: "access" }
    );
  }
}

export default new WatercraftTypeService();
